import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {deleteBrand, hideDeleteBrandModal} from "./actions";
import DeleteFormModal from "../common/DeleteFormModal";

const DeleteBrandModal = ({
                            onDelete,
                            brand,
                            brandDeleting,
                            hideDeleteBrandModal,
                            deleteBrand,
                            visible
                          }) => {
  const brandHandle = {brandId: brand.brandId};
  return (
    <DeleteFormModal entityType="Brand" entityName={brand.name} entityHandle={brandHandle} visible={visible}
                     entityDeleting={brandDeleting} deleteEntity={deleteBrand}
                     hideDeleteFormModal={hideDeleteBrandModal} onDelete={onDelete}/>);
};

DeleteBrandModal.propTypes = {
  onDelete: PropTypes.func.isRequired,
  /* state */
  visible: PropTypes.bool.isRequired,
  brand: PropTypes.object,
  brandDeleting: PropTypes.bool.isRequired,
  /* actions */
  hideDeleteBrandModal: PropTypes.func.isRequired,
  deleteBrand: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  visible: state.brand.deleteBrandModalVisible,
  brand: state.brand.brandToDelete,
  brandDeleting: state.brand.brandDeleting,
});

const mapDispatchToProps = dispatch => ({
  hideDeleteBrandModal: bindActionCreators(hideDeleteBrandModal, dispatch),
  deleteBrand: bindActionCreators(deleteBrand, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(DeleteBrandModal);



// WEBPACK FOOTER //
// ./src/Brand/DeleteBrandFormModal.js